import React, { memo, Fragment } from 'react';

import Typography from '@material-ui/core/Typography';

import { headline, subtitle } from '../graphic';

function Header(props) {
  const {
    classes,
  } = props;

  return (
    <Fragment>

{/*
      <Typography
        // gutterBottom
        variant='h1'
        className={classes.headline}
        dangerouslySetInnerHTML={{ __html: headline }}
      />
*/}
      <Typography
        // gutterBottom
        variant='body1'
        className={classes.lead}
        dangerouslySetInnerHTML={{ __html: subtitle }}
      />
    </Fragment>
  );
}

export default memo(Header);
